export function IconList({
  className,
  size = 16,
}: {
  className?: string;
  size?: number | string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g clipPath="url(#clip0_7958_12812)">
        <path d="M2.66797 4H13.3346" />
        <path d="M2.66797 8H13.3346" />
        <path d="M2.66797 12H10.668" />
      </g>
      <defs>
        <clipPath id="clip0_7958_12812">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
